module.exports = __webpack_public_path__ + "static/media/flood-step-icon-white.f484cfcf.svg";